import store from '@/store'
// import { loadMessages } from '../plugins/i18n'

export default async (to, from, next) => {

  if (store.getters['order/order_type'] === null) {
    next({ name: 'home' });
  } else {
    next();
  }
  await store.dispatch("auth/firestore_init");
}
